// extracted by mini-css-extract-plugin
export default {"banner":"banners_banner__EunxB","bannerVideo":"banners_bannerVideo__ThDY2"};